const $modalReviews = $(".js-modal-reviews");
if ($modalReviews.length) {
  const apiKey = $modalReviews.data("api");
  const productId = $modalReviews.data("product-id");
  $.ajax({
    type: "get",
    url: `https://api.yotpo.com/v1/widget/${apiKey}/products/${productId}/reviews.json?sort=time`,
    data: "data",
    dataType: "json",
    success: function (data) {
      let response = data.response;
      let reviews = response.reviews;
      let reviewsHTML = "";
      let $reviewsBody = $(".js-modal-reviews-body");
      let averageScore = 0;

      if (reviews.length > 0) {
        $(".js-product-rating").css("display", "block");
        for (let index = 0; index < reviews.length; index++) {
          let review = reviews[index];
          let customerName = review.user.display_name;
          let starsRating = review.score;
          let reviewDate = changeDate(review.created_at);
          let reviewContent = review.content;
          let reviewComment = review.comment;
          let reviewsBadgeHTML = `
					<div class="reviews-badge reviews-badge--white" data-visible-stars="${starsRating}">
						<div class="reviews-badge__stars">
							<span class="full-star"></span>
							<span class="full-star"></span>
							<span class="full-star"></span>
							<span class="full-star"></span>
							<span class="full-star"></span>
						</div>
					</div>
					`;
          let reviewHTML = `
					<div class="review-block">
						<div class="review-block__head">
							<span>${customerName}</span>
			
							<span>(verified buyer)</span>
						</div>
			
						<div class="review-block__score">
							${reviewsBadgeHTML}
						</div>
			
						<div class="review-block__date">
							<p>Date: ${reviewDate}</p>
						</div>
			
						<div class="review-block__content">
							<p>${reviewContent}</p>
            </div>
            ${
              reviewComment
                ? `
            <a href="#" class="js-show-review-response review-block__action">Show Response</a>
            <div class="review-block__content hidden">
              <strong>Response: </strong>
              ${reviewComment.content}
            </div>
            `
                : ""
            }
					</div>
					`;

          reviewsHTML += reviewHTML;
          averageScore += starsRating;
        }
      } else {
        reviewsHTML = '<p class="no-reviews">No reviews</p>';
      }

      averageScore = averageScore / reviews.length;

      $(".js-review-stars-average").each(function () {
        let $this = $(this);
        let $starIcons = $this.find(".reviews-badge__stars span");
        let counter = 0;

        $starIcons.each(function () {
          let $starIcon = $(this);
          let difference = averageScore - counter;

          let frontZeroRegex = /^0\..*$/;

          if (difference > 0 && !frontZeroRegex.test(difference)) {
            $starIcon.addClass("full-star");
          }

          if (frontZeroRegex.test(difference)) {
            $starIcon.addClass("half-star");
          }

          counter++;
        });

        $this
          .removeClass("hidden")
          .find(".reviews-badge__count span")
          .text(reviews.length);
      });

      $reviewsBody.html(reviewsHTML);

      readMore();
      handleResponses();
    },
  });
}
// format date function
function changeDate(date) {
  let today = new Date(date);
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0");
  let yyyy = today.getFullYear();

  today = dd + "/" + mm + "/" + yyyy;
  return today;
}

// read more functionality
function readMore() {
  if ($(".review-block .review-block__content p").length) {
    let maxLength = 200;

    $(".review-block .review-block__content p").each(function () {
      let myStr = $(this).text();
      if ($.trim(myStr).length > maxLength) {
        let newStr = myStr.substring(0, maxLength);
        let removedStr = myStr.substring(maxLength, $.trim(myStr).length);
        $(this).empty().html(newStr);
        $(this).append(
          '<a href="javascript:void(0);" class="read-more">... <span>Read More</span></a>'
        );
        $(this).append('<span class="more-text">' + removedStr + "</span>");
      }
    });
    $(".read-more").on("click", function (e) {
      e.preventDefault();
      $(this).siblings(".more-text").contents().unwrap();
      $(this).remove();
    });
  }
}

function handleResponses() {
  const responses = document.querySelectorAll(".js-show-review-response");
  if (responses.length > 0) {
    responses.forEach((response) => {
      response.addEventListener("click", (e) => {
        e.preventDefault();
        const responseClasses = response.nextElementSibling.classList;
        responseClasses.toggle("hidden");

        responseClasses.value.includes("hidden")
          ? (response.innerText = "Show Response")
          : (response.innerText = "Hide Response");
      });
    });
  }
}
